module.exports = __webpack_public_path__ + "img/gt4_1.155a6d95.png";